module.exports = __webpack_public_path__ + "static/media/iconeProntuario.d15412dd.svg";